import {
    server
} from "@/api";


export const create = async (sourcing) => {
    return await server().post('api/sourcings', sourcing)
}

export const paginate = async (params) => {
    return await server().get('api/sourcings', { params });
}

export const update = async (id, sourcing) => {
    return await server().post(`api/sourcings/${id}`, sourcing);
}

export const webhookArrived = async (data) => {
    return await server().post('api/sourcings/webhook/arrived', data);
}

export const uploadImage = async (id, image) => {
    return await server().post(`api/sourcings/${id}/image`, {image}, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const updateStatus = async (id, status) => {
    return await server().post(`api/sourcings/${id}/status`, {status});
}

export default {
    create,
    paginate,
    update,
    webhookArrived,
    uploadImage,
    updateStatus
}